<script setup lang="ts">
import { useTopicsQuery } from '~~/src/composables/query/topic/useTopicsQuery'

interface IProps {
  topicId: number

  // Redirects user to topic page on click, default true
  redirect?: boolean
  hideEmptyTopic?: boolean
}

const props = withDefaults(
  defineProps<IProps>(),
  {
    redirect: true,
  },
)
const { topicId, redirect } = toRefs(props)
const filters = useFilters()
const { data: topics } = useTopicsQuery({
  query: {},
})
const topic = computed(() => {
  if (!topics.value)
    return null

  const typeId = filters.value.type_ids?.[0] || 1
  const isTextFilter = typeId === PROMPT_TYPES.Text
  return topics.value
    .filter((topic) => {
      if (!props.hideEmptyTopic)
        return true
      return isTextFilter ? topic.nTextPrompts > 0 : topic.nVisualPrompts > 0
    })
    .find(topic => topic.id === topicId.value)
})

const topicDisplay = computed(() => `${topic.value?.emoji} ${topic.value?.name}`)
</script>

<template>
  <NuxtLink v-if="topic" :to="redirect ? `/topic/${topic.url}` : ''">
    <div
      flex items-center justify-center gap="2px"
      px-3 h-7 rounded-full
      text-darker-gray bg-gray-lighter hover:bg-soft-gray
      transition-colors
      :data-color="`#${topic?.color}`"
      class="topic-colored"
      :style="{
        // TODO: add hover styles
        // color: `#${topic?.color}`,
        // borderColor: `#${topic?.color}`,
        // backgroundColor: `#${topic?.color}32`,
        cursor: redirect ? 'pointer' : 'inherit',
      }"
    >
      <Text variant="caption">
        {{ topicDisplay }}
      </Text>
    </div>
  </NuxtLink>
</template>
